export default function IconA() {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M33.3333 40.0002C40.6971 40.0002 46.6667 34.0306 46.6667 26.6668C46.6667 19.303 40.6971 13.3335 33.3333 13.3335C25.9695 13.3335 20 19.303 20 26.6668C20 34.0306 25.9695 40.0002 33.3333 40.0002Z"
                stroke="#FF8A00"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M61.666 26.6665L61.666 43.3332" stroke="#FF8A00" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M70.0007 35L53.334 35" stroke="#FF8A00" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M56.6667 66.6667V68.6667C57.7712 68.6667 58.6667 67.7712 58.6667 66.6667H56.6667ZM10 66.6667H8C8 67.7712 8.89543 68.6667 10 68.6667V66.6667ZM58.6667 66.6667C58.6667 51.0937 47.5671 38 33.3333 38V42C44.8729 42 54.6667 52.7844 54.6667 66.6667H58.6667ZM33.3333 38C19.0996 38 8 51.0937 8 66.6667H12C12 52.7844 21.7938 42 33.3333 42V38ZM56.6667 64.6667H10V68.6667H56.6667V64.6667Z"
                fill="#FF8A00"
            />
        </svg>
    );
}
